var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLightPdf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 50,
    viewBox: "0 0 40 50",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxs-file-pdf",
    transform: "translate(-6 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M12.772,22.02a3.744,3.744,0,0,0-.93.09v2.945a3.4,3.4,0,0,0,.755.058c1.2,0,1.935-.605,1.935-1.628,0-.915-.635-1.465-1.76-1.465Zm8.718.03a4.6,4.6,0,0,0-1.017.09v6.525a4.078,4.078,0,0,0,.783.045c2.042.015,3.372-1.11,3.372-3.49a2.861,2.861,0,0,0-3.137-3.17Z",
    transform: "translate(3.895 12.68)",
    fill: "#9fabca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M31,3H11A5,5,0,0,0,6,8V48a5,5,0,0,0,5,5H41a5,5,0,0,0,5-5V18ZM19.745,38.475a4.635,4.635,0,0,1-3.24,1.05,5.576,5.576,0,0,1-.77-.045v3.565H13.5V33.2a18.9,18.9,0,0,1,3.047-.2,4.786,4.786,0,0,1,3.05.8,2.924,2.924,0,0,1,1.065,2.308,3.213,3.213,0,0,1-.917,2.37Zm9.517,3.387a7.161,7.161,0,0,1-4.6,1.287A19.25,19.25,0,0,1,22.1,43V33.207A19.867,19.867,0,0,1,25.15,33a6.415,6.415,0,0,1,4.083,1.065,4.414,4.414,0,0,1,1.688,3.76,5.055,5.055,0,0,1-1.658,4.037ZM38.5,34.925H34.67V37.2h3.58v1.835H34.67v4.01H32.4V33.075h6.1ZM31,20.5H28.5V8L41,20.5Z",
    transform: "translate(0 0)",
    fill: "#9fabca"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLightPdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/light_pdf.b36736b41ff66b9ada6922f5707711a7.svg";